import {
  IconButton,
  Menu,
  TableCell,
  TableRow,
  ListItem,
  ListItemIcon,
  Typography
} from '@material-ui/core'
import { withStyles, Theme, createStyles } from '@material-ui/core/styles'
import EditIcon from '@material-ui/icons/Edit'
import MoreIcon from '@material-ui/icons/MoreVert'
import ViewIcon from '@material-ui/icons/RemoveRedEye'
import React, { useState } from 'react'

import { getTranslate } from '../../../localization'
import { LocalizedLink } from '../../../routes/localizedRoutes'
import { BookingDetails } from '../../../types/booking'
import useStyles from './styles/BookingsListTableMobile.styles'

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: '#a5a5a5',
      color: theme.palette.common.white
    },
    body: {
      fontSize: 14
    }
  })
)(TableCell)

const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow)

interface BookingsListTableRowMobileProps {
  data: BookingDetails
  hasAccessToViewBookingDetails: boolean | undefined
  hasAccessToEditBookingDetails: boolean | undefined
}

export const BookingsListTableRowMobile: React.FC<
  BookingsListTableRowMobileProps
> = ({
  data,
  hasAccessToViewBookingDetails,
  hasAccessToEditBookingDetails
}) => {
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null)

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const classes = useStyles()
  return (
    <StyledTableRow key={data.bookingNumber}>
      <StyledTableCell>{data.bookingNumber}</StyledTableCell>
      <StyledTableCell align="left">{data.bookerName}</StyledTableCell>
      <StyledTableCell className={classes.buttonContainer}>
        <IconButton onClick={handleClick} className={classes.button}>
          <MoreIcon />
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}>
          <ListItem
            disabled={!hasAccessToViewBookingDetails}
            button
            component={LocalizedLink}
            to={`/booking/list/${data.bookingNumber}/view`}>
            <ListItemIcon>
              <ViewIcon fontSize="small" />
            </ListItemIcon>
            <Typography variant="inherit">{getTranslate('View')}</Typography>
          </ListItem>
          <ListItem
            disabled={!hasAccessToEditBookingDetails}
            button
            component={LocalizedLink}
            to={`/booking/list/${data.bookingNumber}/edit`}>
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <Typography variant="inherit">{getTranslate('Edit')}</Typography>
          </ListItem>
        </Menu>
      </StyledTableCell>
    </StyledTableRow>
  )
}
